import React, { useEffect, useRef } from 'react'
import NewTable from '../UnifiedList/Provider'
import { useLocation, useHistory  } from 'react-router-dom'
import {saveIntake} from '../DoIntake/utilities'
import {statusLogs} from '../DoIntake/Details/statusLogs'
import { history } from '../history'


export default function ProjectsList(props) {

  const location = useLocation()
  
  /*
  const history = useHistory()
  const previousLocation = useRef(null);
  */


  useEffect(() => {
    const performActions = async () => {
      if (location?.state?.sourcePage === 'details') {
        const { done } = location.state;
        try {
          await saveIntake(done);
          history.replace({ state: {} }); // Clear state to avoid re-triggering
        } catch (e) {
          console.error('Error:', e);
        }
      }
    };
  
    if (location.state?.sourcePage === 'details') {
      performActions();
    }
  }, [location.state]);

  useEffect(() => {
    console.log("Parent component mounted");
    return () => console.log("Parent component unmounted");
  }, []);

  /*
  useEffect(() => {
    return history.listen((location) => {
      // Store the previous location before the new location is set
      previousLocation.current = location;
    });
  }, [history]);

  // Log or use the previous location
  console.log('Current Location:', location);
  console.log('Previous Location:', location,  previousLocation.current);
  */
  


  return (
    <div className="flex-column padding-2 align-start">
      <NewTable {...props} strategy="projects" />
    </div>
  )
}
